import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'negative'
})
export class NegativePipe implements PipeTransform {
  transform(value: string, negativeValues = false): string | number {
    if (
      !value ||
      value.length === 0 ||
      (value.length === 1 && /\-|\./.test(value))
    ) {
      return 0;
    }
    return !negativeValues ? value : /\-/.test(value) ? value : `-${value}`;
  }
}
